export default {
  rainbow: {
    colors: ['#8B00FF', '#2E2B5F', '#0000FF', '#00FF00', '#FFFF00', '#FF7F00', '#FF0000'],
  },
}
